<template>
  <div>
    <top></top>
    <navMenu></navMenu>
    <div class="inner">
      <!-- <Header></Header> -->
      <!-- <nav-img></nav-img> -->
      <navbar></navbar>
      <div class="ablum_main">
        <div class="ablum_banner">
          <div class="yincang">
            <aside-left></aside-left>
          </div>

          <!-- 相册在主体区域的头部 -->
          <div v-show="isshare">
            <ablum-top @shuaxin="zhaopian"></ablum-top>
          </div>

          <div class="ablum_footer" v-if="xiangshow">
            <ablum-main
              class="ablum_main"
              :list="NewalbumList"
              @shuaxin="zhaopian"
            ></ablum-main>
            <ablum-right
              class="ablum_right"
              :list="ShaftList"
              :class="{ dpn: scrollmax }"
            ></ablum-right>
          </div>

          <div v-else>
            <Zanwu></Zanwu>
          </div>
        </div>
      </div>
      <div class="dingbu">
        <scroll-top></scroll-top>
      </div>
    </div>
  </div>
</template>

<script>
import top from "@/components/common/top.vue";
import navMenu from "@/components/common/navMenu.vue";
import URL from "../../api/index";
// 引入主导航栏区域
import Header from "../../components/space/Header";
// 引入主体背景区域
import NavImg from "../../components/space/NavImg";
// 引入导航栏区域
import Navbar from "../../components/space/Navbar";
// 引入相册的头部
import AblumTop from "../../components/space/AblumTop";
// 引入相册的主体
import AblumMain from "../../components/space/AblumMain";
// 引入相册右边时间轴
import AblumRight from "../../components/space/AblumRight";
// 引入返回顶部按钮
import scrollTop from "../../components/space/scrollTop";
//暂无数据
import Zanwu from "../../components/common/zanwu";
import axios from "axios";
import AsideLeft from "../../components/space/Aside";
export default {
  data() {
    return {
      NewalbumList: "",
      ShaftList: "",
      UserInfo: "",
      getSpaceinfo: "",
      xiangshow: true,
      scrolltop: "",
      scrollmax: false,
      iteminfo: "",
      spaceid: "",
      isshare: true,
      isstart: "",
    };
  },
  components: {
    top,
    navMenu,
    Header,
    NavImg,
    Navbar,
    AblumTop,
    AblumRight,
    AblumMain,
    scrollTop,
    Zanwu,
    AsideLeft,
  },
  mounted() {
    localStorage.removeItem("isstart_ablum");
    this.getRecordRjw(JSON.parse(localStorage.getItem("loginInfo")))
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    this.getSpaceinfo = JSON.parse(window.localStorage.getItem("getSpaceinfo"));
    this.iteminfo = JSON.parse(window.localStorage.getItem("iteminfo"));
    if (this.iteminfo) {
      this.spaceid = this.iteminfo.space_id;
      this.isshare = false;
    } else {
      this.spaceid = this.getSpaceinfo.space_id;
      this.isshare = true;
    }
    this.getalbumList();
    this.handleScrollTop();
  },
  methods: {
    // 控制右边时间线显示与隐藏
    handleScrollTop() {
      let that = this;
      // 实时获取滚动条到顶部的距离
      window.onscroll = function () {
        that.scrolltop =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (that.scrolltop > 410) {
          that.scrollmax = true;
        } else {
          that.scrollmax = false;
        }
      };
    },
    getalbumList() {
      var that = this;
      var data = {
        token: that.UserInfo.token,
        spaceid: this.spaceid,
      };
      //获取相册
      this.$post(URL.album, data).then((res) => {
        if (res.result) {
          that.NewalbumList = res.result.albumlist;
          that.ShaftList = res.result.shaft;
        } else {
          that.xiangshow = false;
        }

        if (res.state == 0) {
          that.xiangshow = true;
        } else if (res.state == 1) {
          that.xiangshow = false;
        }
      });
    },
    zhaopian(val) {
      this.getalbumList();
    },
    //数据上报
    getRecordRjw(hh) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_photo",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的相册",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id:  hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
  },
};
</script>

<style lang="less">
.box {
  padding-top: 20px;
}
.ablum_main {
  background-color: #f5f6f8;
  padding: 25px 0;

  // min-height: 1000px;
  .ablum_banner {
    padding: 25px;
    margin: auto;
    // width: 1200px;
    overflow: hidden;
    background-color: #fff;
    box-shadow: 0px 0px 8px 0px rgba(15, 26, 47, 0.06);
    border-radius: 4px;
    .ablum_footer {
      // overflow: hidden;
      .ablum_main {
        float: left;
        width: 960px;
        background-color: #fff;
      }
      .ablum_right {
        display: none;
        float: right;
        position: fixed;
        top: 20%;
        right: 20%;
        margin: 65px 40px 0 0;
      }
      .ablum_right.dpn {
        display: block;
      }
    }
  }
}
.dingbu {
  position: fixed;
  bottom: 30px;
  right: 30px;
}
.yincang {
  position: fixed;
  left: -99999px;
}
.current {
  .el-timeline-item__content {
    color: #409eff;
  }
  .el-timeline-item__node {
    color: #409eff;
  }
}
</style>
